import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface Document {
  name: string;
  file?: File;
  url?: string; // for preview
}

@Component({
  selector: 'app-document-modal',
  templateUrl: './document-modal.component.html',
  styleUrls: ['./document-modal.component.css'],
})
export class DocumentModalComponent {
  documents: Document[] = [];

  constructor(
    public dialogRef: MatDialogRef<DocumentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { documents: Document[] }
  ) {
    this.documents = data.documents || [];
  }

  close(): void {
    this.dialogRef.close();
  }

  handleAddDocumentClick(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  handleFileUpload(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.documents.push({ name: file.name, file });
    }
  }

  getFileExtension(name: string): string {
    return name.split('.').pop() || '';
  }

  getTruncatedName(name: string): string {
    if (name.length > 20) {
      return name.substring(0, 17) + '...';
    }
    return name;
  }

  shouldShowTooltip(name: string): boolean {
    return name.length > 20;
  }

  viewDocument(doc: Document): void {
    // Simple preview logic; could be improved with iframe/pdf viewer
    if (doc.url) {
      window.open(doc.url, '_blank');
    } else if (doc.file) {
      const url = URL.createObjectURL(doc.file);
      window.open(url, '_blank');
    }
  }
}
